var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',[_c('div',{staticClass:"pull-center"},[_vm._v(" © Copyright 2020 - Global Maricruit. All rights reserved. ")]),_c('div',{staticClass:"clearfix"})])])
}]

export { render, staticRenderFns }